import React, { useEffect, useMemo, useRef, useState } from "react";
import TablesTable from "./componenets/TablesTable";
import { useDispatch, useSelector } from "react-redux";
import SidebarForm from "../../../../Common/CommonSidebarForm";
import {
  POST_TABLE_LIST_REQUEST,
  PUT_TABLE_LIST_REQUEST,
  RESET_TABLE_FLAGS,
} from "../../../../Utils/Constant";
import { hasAddAccess } from "../../../../Common/CheckAccess";

const TableList = () => {
  const sidebarRef = useRef();
  const dispatch = useDispatch();
  const { addSuccess, editSuccess, loading } = useSelector(
    (state) => state.table
  );
  const [shouldRefresh, setShouldRefresh] = useState(false);
  const [selectedTable, setSelectedTable] = useState(null);

  const initialValues = {
    name: "",
    capacity: "",
    status: "",
    location: "",
  };
  const statusOption = [
    { label: "Available", value: "available" },
    { label: "Occupied", value: "occupied" },
    { label: "Reserved", value: "reserved" },
    { label: "Not Available", value: "out_of_service" },
  ];

  const tableFields = [
    { name: "name", label: "Table Name", type: "text", required: true },
    {
      name: "status",
      label: "Table Status",
      type: "select",
      required: true,
      options: statusOption,
    },
    {
      name: "capacity",
      label: "Table Capacity",
      type: "number",
      required: true,
    },
    { name: "location", label: "Location", type: "text", required: false },
  ];
  const [permissions, setPermissions] = useState([]);

  const existingPermissions = localStorage.getItem("checkPermission");

  useEffect(() => {
    if (existingPermissions != undefined) {
      const parsedData = JSON.parse(existingPermissions);
      setPermissions(parsedData);
    }
  }, [existingPermissions]);

  useEffect(() => {
    if (addSuccess) {
      setShouldRefresh((prev) => !prev);
      sidebarRef.current?.closeSidebar();
      dispatch({ type: RESET_TABLE_FLAGS });
    }
    if (editSuccess) {
      setShouldRefresh((prev) => !prev);
      sidebarRef.current?.closeSidebar();
      dispatch({ type: RESET_TABLE_FLAGS });
    }
  }, [addSuccess, editSuccess, dispatch]);

  const onSubmit = (formValues) => {
    const hotel_id=localStorage.getItem('hotel_id')

    if (selectedTable) {
      dispatch({
        type: PUT_TABLE_LIST_REQUEST,
        payload: { id: selectedTable.id, data: {...formValues,hotel_id} },
      });
    } else {
      dispatch({ type: POST_TABLE_LIST_REQUEST, payload: {...formValues,hotel_id} });
    }
  };

  return (
    <>
      <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
        <div className="row g-3">
          <div className="col-sm-12">
            <div className="d-flex align-items-center justify-content-between flex-wrap">
              <h3 className="fw-bold mb-0">Table List</h3>
              <div className="col-auto d-flex w-sm-100">
                {hasAddAccess(permissions, "restaurant") && (
                  <button
                    type="button"
                    className="btn btn-dark"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#add-table"
                    aria-controls="add-table"
                    onClick={() => setSelectedTable(null)}
                  >
                    Add Table
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-body ">
                <TablesTable
                  shouldRefresh={shouldRefresh}
                  setShouldRefresh={setShouldRefresh}
                  setSelectedTable={setSelectedTable}
                  selectedTable={selectedTable}
                  selectedItem
                  sidebarRef={sidebarRef}
                  isLoading={loading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <SidebarForm
        ref={sidebarRef}
        id="add-table"
        title={selectedTable === null ? "Add Table" : "Edit Table"}
        initialValues={initialValues}
        fields={tableFields}
        onSubmit={onSubmit}
        selectedItem={selectedTable}
      />
    </>
  );
};
export default TableList;
